import React, { useState } from 'react';
import { Lock, User, Leaf, AlertCircle } from 'lucide-react';

interface LoginProps {
  onLogin: (token: string, user: any) => void;
}

export default function Login({ onLogin }: LoginProps) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await fetch('/api/auth/login/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      const data = await res.json();
      if (res.ok) {
        onLogin(data.token, data.user);
      } else {
        setError(data.error || 'Login yoki parol xato');
      }
    } catch {
      setError("Server bilan aloqa yo'q");
    }
    setLoading(false);
  };

  const inputStyle: React.CSSProperties = {
    width: '100%', padding: '10px 12px 10px 38px',
    border: '1.5px solid #e5e7eb', borderRadius: 10,
    fontSize: 14, outline: 'none', boxSizing: 'border-box',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, #d1fae5 100%)',
      fontFamily: "'Inter', -apple-system, sans-serif",
    }}>
      <div style={{
        width: 400, background: '#fff', borderRadius: 16,
        boxShadow: '0 20px 60px rgba(0,0,0,0.08)',
        overflow: 'hidden',
      }}>
        <div style={{
          background: 'linear-gradient(135deg, #16a34a, #0d7e6e)',
          padding: '32px 32px 28px', textAlign: 'center', color: '#fff',
        }}>
          <div style={{
            width: 56, height: 56, background: 'rgba(255,255,255,0.2)',
            borderRadius: 14, display: 'flex', alignItems: 'center',
            justifyContent: 'center', margin: '0 auto 14px',
          }}>
            <Leaf size={30} />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 700, margin: 0 }}>AgroSmart</h1>
          <p style={{ fontSize: 13, opacity: 0.85, margin: '4px 0 0' }}>
            Chorvachilik boshqaruv tizimi
          </p>
        </div>

        <div style={{ padding: '28px 32px 32px' }}>
          {error && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: 8,
              background: '#fef2f2', color: '#dc2626',
              padding: '10px 14px', borderRadius: 8, marginBottom: 18,
              fontSize: 13, fontWeight: 500,
            }}>
              <AlertCircle size={16} /> {error}
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
                Foydalanuvchi nomi
              </label>
              <div style={{ position: 'relative' }}>
                <User size={16} style={{ position: 'absolute', left: 12, top: 12, color: '#9ca3af' }} />
                <input type="text" value={username} onChange={e => setUsername(e.target.value)}
                  placeholder="admin" required style={inputStyle} />
              </div>
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 6 }}>
                Parol
              </label>
              <div style={{ position: 'relative' }}>
                <Lock size={16} style={{ position: 'absolute', left: 12, top: 12, color: '#9ca3af' }} />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="********" required style={inputStyle} />
              </div>
            </div>
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '12px',
              background: loading ? '#86efac' : 'linear-gradient(135deg, #16a34a, #0d7e6e)',
              color: '#fff', border: 'none', borderRadius: 10,
              fontSize: 15, fontWeight: 600, cursor: loading ? 'wait' : 'pointer',
            }}>
              {loading ? 'Tekshirilmoqda...' : 'Kirish'}
            </button>
          </form>
          <p style={{ textAlign: 'center', fontSize: 11, color: '#9ca3af', marginTop: 20, marginBottom: 0 }}>
            © {new Date().getFullYear()} AgroSmart · v1.0
          </p>
        </div>
      </div>
    </div>
  );
}
